import { Fragment } from 'react';

import useMyCertifications from './UseMyCertifications';

import CertificationBadge from './CertificationBadge';

import Spinner from '@usas/ui-web/components/spinners/Spinner';

import style from './../../LandingPages.module.css';

const MyCertifications = () => {
  const { certifications, isLoading } = useMyCertifications();

  if (isLoading === true) {
    return <Spinner />;
  } else if (Array.isArray(certifications) !== true || certifications.length === 0) {
    return <Fragment />;
  } else {
    return (
      <Fragment>
        <div className={style.SectionBorder}>
          <div className={style.SectionTitle}>My Certifications</div>
          <div className='row usas-extra-top-margin'>
            {certifications.map((certification, i) => <CertificationBadge certification={certification} key={i} />)}
          </div>
        </div>
      </Fragment>
    );
  }
};

export default MyCertifications;